import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { Observable, map } from 'rxjs';
import { TranslateStoreState } from '../store';
import 'moment-timezone';
import { format } from 'date-fns';
import { DatePipeBase } from './date-pipe-base.pipe';
import moment from 'moment';

@Pipe({
  name: 'localDate',
})
export class LocalDatePipe extends DatePipeBase implements PipeTransform {
  constructor(
    protected translateStore: Store<TranslateStoreState>,
    protected translationService: TranslateService,
  ) {
    super(translateStore, translationService);
  }

  transform(
    value: string | number | Date,
    showTime: boolean,
  ): Observable<string> {
    const date = new Date(value);
    const customFormat = `${
      this.currentLanguage === 'en' ? 'MMM dd, yyyy' : 'dd MMM yyyy'
    }${showTime ? ' h:mm a' : ''}`;
    // The goal is to start using date-fns-tz for timezone support. However, we can't upgrade to the latest version yet, because of aureus' dependencies.
    // The version we are able to use does not have the locale data we need up to date, so some locales can't format the timezone correctly.
    const localTime = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const timezone = moment.tz(localTime).format('z');
    const formattedDate = format(date, customFormat);

    // Add the timezone after translating the date, to avoid accidentally replacing the timezone as well.
    return this.translateDate(date, formattedDate).pipe(
      map((translatedDate) =>
        showTime ? `${translatedDate} ${timezone}` : translatedDate,
      ),
    );
  }
}
